
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnfoldMoreGoogle as ObiUnfoldMoreGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-unfold-more-google.js';
 
 
 

 
 export const ObiUnfoldMoreGoogle = createComponent({
   react: React,
   tagName: 'obi-unfold-more-google',
   elementClass: ObiUnfoldMoreGoogleElement,
   events: {
     
   }
  });
 
 